'use client';

import { useRef } from 'react';
import { ResourcesConfig } from 'aws-amplify';
import { configure } from './config';

export interface AmplifyClientProps {
  config: ResourcesConfig;
}

/**
 * Bootstraps the Amplify client with the provided configuration once,
 * This runs on the client, as expected by the Amplify connected components.
 */
export function AmplifyClient({ config }: AmplifyClientProps) {
  const init = useRef(false);
  if (!init.current) {
    configure(config);
    init.current = true;
  }

  return null;
}
